function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 13a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.799 6.713a.795.795 0 01-.942.029l-.902-.626a.625.625 0 00-.788.063.542.542 0 00-.036.744l1.463 1.713a1.057 1.057 0 001.549.05l3.71-3.8a.507.507 0 00-.009-.722.587.587 0 00-.769-.039L5.8 6.713z",
  fill: "#fff"
});

var SvgCircleCheckChecked = function SvgCircleCheckChecked(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z' fill='currentColor' /%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.79882 6.71282C5.52737 6.92719 5.14214 6.93893 4.85743 6.7415L3.95491 6.11566C3.71138 5.94679 3.37801 5.97374 3.1665 6.17941C2.95886 6.38132 2.94354 6.70379 3.13115 6.92345L4.59385 8.63606C4.61995 8.66663 4.64789 8.69566 4.67752 8.72302C5.09263 9.10629 5.74865 9.08976 6.1428 8.68611L9.85384 4.88551C10.0524 4.68216 10.0481 4.36198 9.84422 4.1637C9.63599 3.96121 9.30406 3.94453 9.07547 4.12506L5.79882 6.71282Z' fill='white' /%3E %3C/svg%3E";
export { SvgCircleCheckChecked as ReactComponent };